"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7546,3323,1274],{

/***/ 28600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34427);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(81663);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92734);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22040);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93359);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92021);
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40865);
/* harmony import */ var swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_swiper_min_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swiper_css_lazy__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20610);
/* harmony import */ var swiper_css_lazy__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_lazy__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42470);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2580);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(43493);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19599);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99619);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48576);
/* harmony import */ var provider_Slider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59827);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79307);






// TODO: update











var useStyle = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function(theme) {
    var _obj, _obj1;
    return {
        wrapper: (_obj = {
            position: "relative",
            height: 600,
            width: "100%",
            display: "flex",
            "& .swiper-wrapper": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                boxSizing: "border-box"
            }, theme.breakpoints.only("lg"), {
                width: "55rem"
            }),
            "& .swiper-slide": (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, theme.breakpoints.between("md", "lg"), {
                height: "40rem !important",
                position: "relative"
            }),
            "& .swiper-container": {}
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, theme.breakpoints.between("xs", "sm"), {
            height: "30rem !important",
            position: "relative"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, theme.breakpoints.between("sm", "md"), {
            height: "30rem !important",
            position: "relative"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, theme.breakpoints.between("md", "lg"), {
            height: "60rem !important",
            position: "relative"
        }), _obj),
        direction: {},
        dots: {
            display: "flex",
            transform: "rotate(0)",
            height: "auto"
        },
        dotsVertical: (_obj1 = {
            display: "flex",
            flexDirection: "column",
            height: "8rem",
            position: "relative",
            top: "65%"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj1, theme.breakpoints.between("md", "lg"), {
            top: "35%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj1, theme.breakpoints.only("lg"), {
            top: "55%"
        }), _obj1),
        dot: {
            border: "none",
            height: "0.5rem",
            width: "0.4rem",
            background: theme.palette.background.light,
            borderRadius: "50%",
            margin: "0 0.5rem",
            padding: "0.4rem 0.5rem",
            cursor: "pointer",
            "&:focus": {
                outline: "none"
            }
        },
        dotVertical: {
            border: "none",
            height: ".4rem",
            width: "0.5rem",
            background: theme.palette.background.light,
            borderRadius: "36px",
            margin: "0.5rem 0",
            padding: "0.5rem 0.3rem",
            cursor: "pointer",
            "&:focus": {
                outline: "none"
            }
        },
        active: {
            background: theme.palette.secondary[700],
            width: "2rem",
            borderRadius: "3.2rem",
            boxShadow: "-0.3rem 0.1rem 0.9rem ".concat(theme.palette.secondary[700])
        },
        activeVertical: {
            background: theme.palette.secondary[700],
            height: "2rem",
            borderRadius: "3.2rem",
            boxShadow: "0.1rem 0.1rem 0.9rem ".concat(theme.palette.secondary[700])
        }
    };
});
var SwiperKit = function(props) {
    var ref, ref1, ref2;
    var classes = useStyle();
    var children = props.children, rootClassName = props.rootClassName, innerProps = props.innerProps;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useContext)(provider_Slider__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z), state = ref3.state, setState = ref3.setState;
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(rootClassName ? rootClassName : classes.wrapper, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, classes.direction, !(innerProps === null || innerProps === void 0 ? void 0 : (ref = innerProps.direction) === null || ref === void 0 ? void 0 : ref.includes("vertical")))),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                className: "swiper",
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Lazy */ .oM,
                    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Autoplay */ .pt
                ],
                onSwiper: function(_swiper) {
                    setState(function(prev) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, prev), {
                            _swiper: _swiper
                        });
                    });
                },
                freeMode: true,
                onSlideChange: function(param) {
                    var activeIndex = param.activeIndex, realIndex = param.realIndex, slides = param.slides;
                    setState(function(s) {
                        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, s), {
                            activeIndex: activeIndex,
                            miniStep: realIndex + 1,
                            slides: (slides === null || slides === void 0 ? void 0 : slides.length) - 2
                        });
                    });
                }
            }, innerProps), {
                children: [
                    !props.proMode && props.data.map(function(item, key) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                            children: [
                                props.mode === "image" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_8__["default"], (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                            src: item.img,
                                            quality: 65
                                        }, props.imageProperty), {
                                            priority: true
                                        })),
                                        innerProps.lazy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "swiper-lazy-preloader swiper-lazy-preloader-white"
                                        })
                                    ]
                                }),
                                props.mode === "element" && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_4__.cloneElement(children, item)
                            ]
                        }, "image-of-item-".concat(key));
                    }),
                    props.proMode && react__WEBPACK_IMPORTED_MODULE_4__.Children.map(children, function(child, i) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                            className: (child === null || child === void 0 ? void 0 : child.props.className) ? "swiper-slide ".concat(child.props.className) : "swiper-slide",
                            children: [
                                child,
                                innerProps.lazy && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "swiper-lazy-preloader swiper-lazy-preloader-white"
                                })
                            ]
                        }, "featuredCape-".concat(i));
                    })
                ]
            })),
            props.bullet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                className: props.bullet ? props.bullet : "",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.dots, !(innerProps === null || innerProps === void 0 ? void 0 : (ref1 = innerProps.direction) === null || ref1 === void 0 ? void 0 : ref1.includes("vertical"))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.dotsVertical, innerProps === null || innerProps === void 0 ? void 0 : (ref2 = innerProps.direction) === null || ref2 === void 0 ? void 0 : ref2.includes("vertical")), _obj)),
                    children: react__WEBPACK_IMPORTED_MODULE_4__.Children.toArray(Array(3).fill("").map(function(_, idx) {
                        var ref, ref1, ref2, ref3, ref4;
                        var _obj;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            component: "span",
                            onClick: function() {
                                setState(function(prev) {
                                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, prev), {
                                        activeIndex: idx + 1
                                    });
                                });
                                state._swiper.slideToLoop(idx);
                            },
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.active, (state === null || state === void 0 ? void 0 : (ref = state._swiper) === null || ref === void 0 ? void 0 : ref.realIndex) === idx + 1 && !(innerProps === null || innerProps === void 0 ? void 0 : (ref1 = innerProps.direction) === null || ref1 === void 0 ? void 0 : ref1.includes("vertical"))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.activeVertical, (state === null || state === void 0 ? void 0 : (ref2 = state._swiper) === null || ref2 === void 0 ? void 0 : ref2.realIndex) === idx), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.dot, !(innerProps === null || innerProps === void 0 ? void 0 : (ref3 = innerProps.direction) === null || ref3 === void 0 ? void 0 : ref3.includes("vertical"))), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_obj, classes.dotVertical, innerProps === null || innerProps === void 0 ? void 0 : (ref4 = innerProps.direction) === null || ref4 === void 0 ? void 0 : ref4.includes("vertical")), _obj))
                        });
                    }))
                })
            })
        ]
    });
};
SwiperKit.defaultProps = {
    data: [],
    swiperRef: null,
    innerProps: {
        direction: "vertical",
        lazy: true,
        modules: [],
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        slidesPerView: 1
    },
    mode: "image",
    proMode: false,
    bullet: false
};
SwiperKit.prototype = {
    data: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().array.isRequired),
    mode: prop_types__WEBPACK_IMPORTED_MODULE_15___default().oneOf([
        "image",
        "element"
    ]),
    proMode: (prop_types__WEBPACK_IMPORTED_MODULE_15___default().bool.isRequired)
};
/* harmony default export */ __webpack_exports__["default"] = (SwiperKit);


/***/ })

}]);